/**
 * Typed ops unattested device API facade over the generated contract client.
 */

import { opsUnattestedApi } from '../api/generated/opsUnattested.api.js';
import {
  type UnattestedAttemptDetailResponse,
  type UnattestedAttemptListQuery,
  type UnattestedAttemptListResponse,
} from '@cnapse/shared/schemas.js';

class OpsUnattestedService {
  async getUnattestedAttemptList(
    query: UnattestedAttemptListQuery,
  ): Promise<UnattestedAttemptListResponse> {
    return opsUnattestedApi.list(query) as Promise<UnattestedAttemptListResponse>;
  }

  async getUnattestedAttemptDetail(attemptId: string): Promise<UnattestedAttemptDetailResponse> {
    return opsUnattestedApi.getDetail({ attemptId }) as Promise<UnattestedAttemptDetailResponse>;
  }
}

export const opsUnattestedService = new OpsUnattestedService();
